import { checkAccessToPath } from 'frontend/common/access-helpers'
import { computed } from 'vue'
import {ResourceSectionType} from 'frontend/common/layout/enum/resource-section-type'

export function useResourcesSection(eou) {
  function hasAccessTo(path) {
    return checkAccessToPath(eou.value, path)
  }

  const section = computed(() => {
    const result = {
      name: 'Resources',
      sectionType: ResourceSectionType.Resources,
      items: [
        {
          title: 'Vehicles',
          isDisabled: false,
          path: 'vehicles',
          icon: 'mi-outlined mi-directions-car',
        },
        {
          title: 'Drivers',
          isDisabled: false,
          path: 'drivers',
          icon: 'mi-outlined mi-badge',
        },
        {
          title: 'Clients',
          isDisabled: false,
          path: 'clients',
          icon: 'mi-outlined mi-recent-actors',
        },
        {
          title: 'Shifts',
          isDisabled: false,
          path: 'shifts',
          icon: 'mi-outlined mi-change-circle',
        },
        {
          title: 'Driver Registration QR Tokens',
          isDisabled: false,
          path: 'driver-registration-qr-tokens',
          icon: 'bi-qr-code',
        },
        {
          title: 'Driver Registration Requests',
          isDisabled: false,
          path: 'driver-registration-requests',
          icon: 'bi-person-badge',
        },
        {
          title: 'Reports',
          isDisabled: false,
          path: 'reports',
          icon: 'far fa-file-excel',
        },
      ],
    }
    result.items = result.items.filter(el => hasAccessTo(el.path))
    if (result.items.length) {
      return result
    } else {
      return {}
    }
  })

  return section
}
